import { Component, Input } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'app-select-info-banner',
  templateUrl: './select-info-banner.component.html',
  styleUrls: ['./select-info-banner.component.scss']
})
export class SelectInfoBannerComponent {
  @Input() public totalItems: number;
  @Input() public linkAllItems: boolean;
  @Input() public selectAllItems: () => any;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

}
